import React, { useState } from "react";

import { Box, Grid, Button, Typography, Card, CircularProgress } from "@material-ui/core";
import { Field, Formik, Form } from "formik";
import { formattedDate, formattedTime } from "../../../../utils/date";
import FormikControl from "../../../FormikCustoms/FormikControl";
import TextLabel from "../../../Shared/TextLabel";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import useStyles from "./styles";



function TabAvailable({
  value,
  editingItem,
  setEditingItem,
  index,
  setTab,
  dates,
  turns,
  isLoadingTurn,
  clearedTurn,
  setClearedTurn,
  ...other
}) {
  const classes = useStyles();
  const [feedback, setFeedback] = useState({});

  const [turnLabel, setTurnLabel] = useState();
  const [start, setStart] = useState();
  const [end, setEnd] = useState();

  const handleOnFeedback = () => {
    if (feedback.success) {
      //   handleOnclose();
    } else {
      setFeedback({});
    }
  };

  const handleOnSubmit = async (values, setSubmitting) => {
    setEditingItem({
      ...editingItem,
      date: formattedDate(values.date),
      turno: values.turn,
      turnLabel: turnLabel,
      starts_at: start,
      ends_at: end,
    });
    setSubmitting(false);
    setTab(3);
  };
  const validateForm = (values) => {
    const errors = {};

    if (!values.date) {
      errors.date = "Selecione uma data.";
    }

    if (!values.turn) {
      errors.turn = "Selecione um turno";
    }

    return errors;
  };

  const availableTurns = (turn) => {
      const t = turn.map((item) => item?.available).reduce((total, present) => {return total + present}, 0);
      return t;
  };

  return (
    <>
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      />
      {value === index && (
        <Box
          height="100%"
          width="100%"
          justifyContent="center"
          alignItems="center"
          display="flex"
          flexDirection="column"
          p={3}
        >
          {!Object.keys(feedback).length ? (
            <Formik
              initialValues={{
                date: null,
                turn: editingItem.turno ?? "",
              }}
              validate={(values) => validateForm(values)}
              onSubmit={(values, { setSubmitting }) =>
                handleOnSubmit(values, setSubmitting)
              }
            >
              {({ setFieldValue, submitForm, isSubmitting, values }) => (
                <Form className={classes.formik}>
                  <Grid container>
                    <Grid item md={6} xs={12}>
                      <Grid
                        item
                        md={4}
                        xs={12}
                        m={4}
                        className={classes.calendar}
                      >
                        <Typography
                          className={classes.title}
                          color="textPrimary"
                          gutterBottom
                        >
                          Selecione um dia na Agenda
                        </Typography>
                        <FormikControl
                          control="calendar"
                          name="date"
                          availableDays={dates}
                          value={null}
                          data-cy="scheduller-day"
                          id="scheduller-day"
                          onChange={(date) => {
                            setFieldValue("date", date);
                            setEditingItem({
                              ...editingItem,
                              date: formattedDate(date),
                            });
                            setClearedTurn(false)
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <Box flexDirection="row" display="flex" p={3}>
                        <Grid>
                          <LocationOnIcon />
                        </Grid>
                        <Box flexDirection="column" display="flex">
                          <span>Unidade Cargill</span>
                          <span>
                            <strong>{editingItem.branchLabel}</strong>
                          </span>
                        </Box>
                      </Box>
                        {(isLoadingTurn === true) ? <CircularProgress/> : (clearedTurn === true) ? null : availableTurns(turns) ?  (
                          turns.map((item, index) => (
                            <Grid key={item.id} item md={8} xs={12} m={4} p={3}>
                              <Card className={classes.root}>
                                <Field
                                  name="turn"
                                  render={({ field }) => (
                                    <input
                                      type="radio"
                                      name="turn"
                                      data-cy={`turn-${item.id}`}
                                      id={`turn-${item.id}`}
                                      value={item.id}
                                      checked={field.value === item.id}
                                      onChange={() => {
                                        setTurnLabel(item.description);
                                        setStart(item.starts_at);
                                        setEnd(item.ends_at);
                                        setFieldValue("turn", item.id);
                                      }}
                                    />
                                  )}
                                />
                                <Grid item md={6} xs={12} p={3}>
                                  <label>Turno</label>
                                  <Typography
                                    className={classes.title}
                                    color="textPrimary"
                                    gutterBottom
                                  >
                                    {`${item.description} - (${formattedTime(item.starts_at)} até ${formattedTime(item.ends_at)})`}
                                  </Typography>
                                </Grid>
                                <Grid item md={5} xs={12}>
                                  <TextLabel
                                    label={
                                      item.available
                                        ? `Existem ${item.available} cotas disponíveis.`
                                        : `Não existem cotas disponíveis!`
                                    }
                                  />
                                </Grid>
                              </Card>
                            </Grid>
                          ))
                        ) : (<div><label>Não existem cotas disponíveis para o dia selecionado.</label></div>
                        )}
                    </Grid>
                  </Grid>
                  <Box
                    width="100%"
                    justifyContent="space-between"
                    alignItems="flex-end"
                    display="flex"
                    flexDirection="row"
                    p={2}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      autoFocus
                      data-cy="back-btn"
                      id="back-btn"
                      size="large"
                      className={classes.backButton}
                      onClick={() => {
                        setTab(1);
                      }}
                    >
                      Voltar
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      autoFocus
                      data-cy="foward-btn"
                      id="foward-btn"
                      size="large"
                      className={classes.nextButton}
                      disabled={isSubmitting}
                      onClick={submitForm}
                    >
                      Avançar
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h5">{feedback.message}</Typography>
              </Grid>
              <Grid item xs={12}>
                <div
                  style={{
                    display: "flex",
                    height: 56,
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    onClick={handleOnFeedback}
                    variant="contained"
                    data-cy="available-back-btn"
                    id="available-back-btn"
                    color="primary"
                    style={{ minWidth: "50%" }}
                    size="large"
                  >
                    {feedback.success ? "Voltar" : "Tentar novamente"}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </Box>
      )}
    </>
  );
}

export default TabAvailable;
